import axios from "axios";
// import { setUnAuthenticationsCount } from 'redux/reducers/authSlice';
import store from "redux/store";
import RoutePaths from "routes/RoutePaths";
import {
  ACCESS_DENIED,
  ACCESS_DENIED_STATUS,
  AUTH,
  BEARER,
  DEFAULT_TIME_OUT,
  INTERNAL_SEVER_STATUS,
  NotificationType,
  SUCCESS_STATUS,
  UNAUTHORIZED_STATUS,
  CONFIGURATION,
} from "utils/constants";
// import { getNewToken } from 'utils/helper/GetNewToken';
// import { tokenExpireTimeDifference } from 'utils/helper/GetTokenExpireTimeDifference';
// import { notifications } from 'utils/helper/Notification';

//SET BASE URL
const baseUrl = CONFIGURATION.baseUrl;
const options = {
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
    Accept: "*/*",
  },

  timeout: DEFAULT_TIME_OUT,
};

export const axiosClient = axios.create(options);

axiosClient.interceptors.request.use(
  async (config) => {
    const state = store.getState();
    const {auth} = state;
    const headers = config.headers;
    config.headers = {
      ...headers,
      [AUTH]: `${BEARER} ${auth.authUser?.token}`,
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);
